export default __webpack_public_path__ + "static/media/youtube.839ac6a5.svg";